var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-to-top-button",on:{"click":_vm.handleClick}},[_c('icon',{attrs:{"icon":"caret-up","colour":"dark-navy"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }